import React, { useEffect, useRef, forwardRef } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./index.css";
import { ErrorLabel, FormLabel } from "@ui/internal/components/label";

interface phonePickerProp {
  value: string;
  label?: string;
  error?: string;
  onChange: (value: string) => void;
  name: string;
}

// 👇 Forward ref manually
const PhonePicker = forwardRef<HTMLInputElement, phonePickerProp>(
  ({ label, error, ...props }, ref) => {
    const internalRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
      if (ref && typeof ref === "object" && ref !== null) {
        (ref as React.MutableRefObject<HTMLInputElement | null>).current =
          internalRef.current;
      }
    }, [ref]);

    return (
      <div className={`flex flex-col   w-full ${error ? "required" : ""}`}>
        {label && <FormLabel label={label} />}

        <PhoneInput
          country={"np"}
          inputClass="min-w-[90%]  shadow-sm disabled:bg-[#f8fafc] disabled:text-[#75859c]"
          disableCountryGuess={true}
          containerClass="disabled:bg-[#f8fafc] disabled:text-[#75859c]"
          searchClass="disabled:bg-[#f8fafc] disabled:text-[#75859c]"
          buttonClass="disabled:bg-[#f8fafc] disabled:text-[#75859c]"
          countryCodeEditable={true}
          {...props}
          inputProps={{
            name: props.name,
            ref: internalRef, // 👈 give ref to real input
          }}
        />
        {error && <ErrorLabel className="!mt-[-12px]" message={error} />}
      </div>
    );
  }
);

PhonePicker.displayName = "PhonePicker";

export default PhonePicker;
